/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  event.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:29
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/**
 * 商品规格列表传输
 */
export const goodsSpecificationListEvent = 'goodsSpecificationListEvent'
/**
 * 商品套餐列表传输
 */
export const goodsPackageListEvent = 'goodsPackageListEvent'
/**
 * 商品开启规格值传输
 */
export const multiSpecEvent = 'multiSpecEvent'
/**
 * 商品轮播图传输
 */
export const goodsBannerImage = 'goods-banner-image'
/**
 * 商品编码值传输
 */
export const goodsCodeEvent = 'goods-code-event'
/**
 * 商品规格删除传输
 */
export const goodsSpecDelete = 'goods-spec-delete'
